import React, { useEffect } from "react";
import {
  Box,
  Button,
  Grid,
  IconButton,
  MenuItem,
  Modal,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { AddCircle, RemoveCircle } from "@mui/icons-material";
import { useFormik } from "formik";
import * as yup from "yup";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { createService } from "../../redux/Slice/serviceslice";
import { setLoading } from "../../redux/Slice/loaderSlice";
import { toast } from "sonner";
import { clearMessage } from "../../redux/Slice/message";
import PersonAddAlt1Icon from "@mui/icons-material/PersonAddAlt1";

const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: 400,
  bgcolor: 'background.paper',
  boxShadow: 24,
  borderRadius: 3,
  p: 4,
};

// Form validation schema using Yup
const validationSchema = yup.object().shape({
  name: yup
    .string()
    .required("Service type is required"),
});

const CreateService = () => {

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const message = useSelector((state) => state.message);

  useEffect(() => {
    if (message?.message) {
      toast(message.message)
      dispatch(clearMessage())
    }
  }, [message, dispatch])

  const formik = useFormik({
    initialValues: {
      name: "",
      status: true,
    },
    validationSchema,
    onSubmit: (values) => {
      dispatch(setLoading(true));
      dispatch(createService({ ...values }))
        .unwrap()
        .then(() => {
          dispatch(setLoading(false));
          navigate("/services");
          handleClose();
        })
        .catch(() => {
          dispatch(setLoading(false));
        });
    },
  });

  const handleAddFeature = () => {
    formik.setFieldValue("features", [...formik.values.features, { key: "", value: "" }]);
  };

  const handleRemoveFeature = (index) => {
    const updatedFeatures = [...formik.values.features];
    updatedFeatures.splice(index, 1);
    formik.setFieldValue("features", updatedFeatures);
  };

  return (
    <>
    <Button variant="contained" onClick={handleOpen} startIcon={<PersonAddAlt1Icon />}  sx={{ ml: 2, px: 3 }}>
            Add
      </Button>
<Modal
  open={open}
  onClose={handleClose}
  aria-labelledby="modal-modal-title"
  aria-describedby="modal-modal-description"
>
    <Box
      sx={style}
    >
      <Typography variant="h5" marginBottom={3}>
        Create Service
      </Typography>
      <form onSubmit={formik.handleSubmit}>
        {/* Service Type */}
        <Box marginBottom={4}>
        <TextField
                  fullWidth
                  placeholder="Enter Service Name"
                  variant="outlined"
                  name='name'
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={
                    formik.touched.name &&
                    Boolean(formik.errors.name)
                  }
                  helperText={
                    formik.touched.name &&
                    formik.errors.name
                  }
                />
        </Box>

        {/* Submit Button */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            marginTop: 4,
          }}
        >
          <Button type="submit" variant="contained" color="primary">
            Create Service
          </Button>
        </Box>
      </form>
    </Box>
</Modal>
</>
  );
};

export default CreateService;
